import qs from "qs";
import { FilterDef, HTTPGenericResponse } from "../../constants/FinanceModels";
import * as Const from "../../pages/amex/constants/CardConstants";
import { getFilterValue } from "../../utils/FilterUtils";
import { useApi } from "../Api";
import dayjs from "dayjs";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import {useContext} from "react";
import {ID_FILTER_DEALERS, ID_FILTER_LEGAL_ENTITIES} from "../../pages/invoices/constants/InvoicesFilters";

export const useCardsRepository = () => {
    const { GET, POST, PUT, DELETE } = useApi();

    const PATH = "/finance/amexsof/cards"

    const {
        globalData: { user },
    } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities
        ?.filter((x: any) => x.name.toLowerCase() !== "all")
        .map((x: any) => x.name);

    async function getCard(id: string): Promise<HTTPGenericResponse> {
        let response = await GET(`${PATH}/${id}`, {});
        return new Promise((resolve) => {
            let generic: HTTPGenericResponse = {
                code: 200,
                status: 'OK',
                message: '',
                result: response
            }
            resolve(generic);
        })
    }

    async function getCards(offset: number, limit: number, sort: string | null, order: string | null, filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let customer = getFilterValue(Const.ID_FILTER_CUSTOMER, filterDefs);
        let statuses = getFilterValue(Const.ID_FILTER_STATUS, filterDefs);
        let networkCode = getFilterValue(Const.ID_FILTER_NETWORK_CODE, filterDefs);
        let pan = getFilterValue(Const.ID_FILTER_PAN, filterDefs);
        let panAlias = getFilterValue(Const.ID_FILTER_PAN_ALIAS, filterDefs);
        let panAliasCustomer = getFilterValue(Const.ID_FILTER_PAN_ALIAS_CUSTOMER, filterDefs);
        
        let expirationDateFrom: Date = getFilterValue(Const.ID_FILTER_EXPIRATION_DATE_FROM, filterDefs);
        let expirationDateTo: Date = getFilterValue(Const.ID_FILTER_EXPIRATION_DATE_TO, filterDefs);
        let legalEntities: string[] = getFilterValue(ID_FILTER_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_DEALERS, filterDefs);

        let params = {
            offset: offset,
            limit: limit,
            sortBy: sort,
            order: order,
            customerNameOrCompany: customer,
            status: statuses,
            networkCode,
            pan, panAlias, panAliasCustomer,
            expirationDateFrom: expirationDateFrom ? dayjs(expirationDateFrom).toISOString() : null,
            expirationDateTo: expirationDateTo ? dayjs(expirationDateTo).toISOString() : null,
            legalEntities,
            dealers
        }

        let response = await GET(`${PATH}`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
        return new Promise((resolve) => {
            let generic: HTTPGenericResponse = {
                code: 200,
                status: 'OK',
                message: '',
                result: response
            }
            resolve(generic);
        })
    }

    async function postCard(card: any): Promise<HTTPGenericResponse> {
        let response = await POST(`${PATH}`, card, {}, true);
        return new Promise((resolve) => {
            let generic: HTTPGenericResponse = {
                code: 200,
                status: 'OK',
                message: '',
                result: response
            }
            resolve(generic);
        })
    }

    async function putCard(card: any): Promise<HTTPGenericResponse> {
        let response = await PUT(`${PATH}/${card.id}`, card, {}, true);
        return new Promise((resolve) => {
            let generic: HTTPGenericResponse = {
                code: 200,
                status: 'OK',
                message: '',
                result: response
            }
            resolve(generic)
        })
    }

    async function deleteCard(card: any): Promise<HTTPGenericResponse> {
        let response = await DELETE(`${PATH}/${card.id}`,{}, true);
        return new Promise((resolve) => {
            let generic: HTTPGenericResponse = {
                code: 200,
                status: 'OK',
                message: '',
                result: response
            }
            resolve(generic)
        })
    }

    async function putCardStatus(card: any): Promise<HTTPGenericResponse> {
        let response = await PUT(`${PATH}/${card.id}/status?status=`+ card.status, {}, {}, true);
        return new Promise((resolve) => {
            let generic: HTTPGenericResponse = {
                code: 200,
                status: 'OK',
                message: '',
                result: response
            }
            resolve(generic);
        })
    }


    return { getCard, getCards, postCard, putCard, putCardStatus, deleteCard };
}